import type { Sample } from '../api';
import { formatTime } from '../../../shared/format';

type Props = {
  startedAt: string | null;
  endedAt: string | null;
  durationS: number;
  cursor: string | null;
  playing: boolean;
  speed: number;
  sample: Sample | null;
  readOnly?: boolean;
  onToggle: () => void;
  onSeek: (seconds: number) => void;
  onSpeed: (speed: number) => void;
};

export default function Timeline({
  startedAt,
  endedAt,
  durationS,
  cursor,
  playing,
  speed,
  sample,
  readOnly = false,
  onToggle,
  onSeek,
  onSpeed,
}: Props) {
  const offset =
    startedAt && cursor
      ? Math.max(0, (new Date(cursor).getTime() - new Date(startedAt).getTime()) / 1000)
      : 0;
  const inactive = !startedAt || durationS <= 0;

  return (
    <div className={`timeline${readOnly ? ' read-only' : ''}`}>
      <button
        type="button"
        className="btn btn-primary btn-sm"
        onClick={onToggle}
        disabled={inactive || readOnly}
      >
        {playing ? '暂停' : '播放'}
      </button>

      <div className="speed" aria-label="播放速度">
        {[1, 2, 5, 10].map((value) => (
          <button
            key={value}
            type="button"
            className={speed === value ? 'on' : ''}
            onClick={() => onSpeed(value)}
            disabled={readOnly}
          >
            {value}×
          </button>
        ))}
      </div>

      <input
        className="range"
        type="range"
        min={0}
        max={Math.max(1, durationS)}
        step={0.1}
        value={Math.min(offset, Math.max(1, durationS))}
        onChange={(event) => onSeek(Number(event.target.value))}
        disabled={inactive || readOnly}
        aria-label="回放时间轴"
      />

      <span className="time-label">
        {formatTime(cursor)} / {formatTime(endedAt)}
      </span>
      <span className="time-label data-time">数据时间 {formatTime(sample?.ts)}</span>
    </div>
  );
}